<template>
  <div class="page full" id="regist">
    <img class="banner" src="~@/assets/header-img_02.jpg" />
    <div class="form">
    <van-form @submit="onSubmit">
      <van-field
        readonly
        clickable
        name="school"
        :value="school_v"
        label="就读学校"
        placeholder="点击选择就读学校"
        @click="showSchool = true"
         :rules="[{ required: true,}]"
      />
      <van-field
        readonly
        clickable
        name="grade"
        :value="grade_v"
        label="年级班级"
        placeholder="点击选择就读年级"
        @click="showGrade = true"
         :rules="[{ required: true,}]"
      />
      <van-field
        v-model="stuname"
        name="stuname"
        label="学生姓名"
        placeholder="请输入学生姓名"
        :rules="[{ required: true,}]"
      />
      <van-field
        v-model="parname"
        name="parname"
        label="家长姓名"
        placeholder="请输入家长姓名"
        :rules="[{ required: true,}]"
      />
      <van-field
       :rules="[{ required: true,}]"
        readonly
        clickable
        name="relationship"
        :value="relationship_v"
        label="家庭关系"
        placeholder="点击选择与学生家庭关系"
        @click="showRelationship = true"
      />
      <van-field
        v-model="phone"
        name="phone"
        label="手机号码"
        placeholder="请输入您的手机号码"
        :rules="[{ pattern, required: true,}]"
      />
      <div style="margin: 16px;">
        <van-button color="#e2353f" round block type="info" native-type="submit">提交</van-button>
      </div>
    </van-form>
    </div>


    <van-popup v-model="showSchool" position="bottom">
      <van-picker
        show-toolbar
        :columns="school"
        @cancel="showSchool = false"
        @confirm="onConfirm_school"
      />
    </van-popup>
    <van-popup v-model="showGrade" position="bottom">
      <van-picker
        show-toolbar
        :columns="grade"
        @cancel="showGrade = false"
        @confirm="onConfirm_grade"
      />
    </van-popup>
    <van-popup v-model="showRelationship" position="bottom">
      <van-picker
        show-toolbar
        :columns="relationship"
        @confirm="onConfirm_relationship"
        @cancel="showRelationship = false"
      />
    </van-popup>
  </div>
</template>

<script>
import index from "./index.js";
export default { ...index };
</script>

<style lang="scss">
@import "./index.scss";
</style>
